export default __webpack_public_path__ + "static/media/profile-marker.59ea150f.svg";